angular.module('shared').factory('EzidebitService', function() {
  return {
    getCustomerReference: function(params) {
      var rnd;
      rnd = Math.floor(Math.random() * 10000000000);
      return `${params.gymId}-${params.context}-${params.contactId || 'NEW'}-${moment().unix()}-${rnd}`;
    },
    transliterate: function(str) {
      if (!str) {
        return '';
      }
      return str.normalize('NFD').replace(new RegExp('[\\u0300-\\u036f]', 'gu'), '').replace(new RegExp('[^\\x00-\\x7F]', 'gu'), '?');
    }
  };
});
